import React from 'react';
import { RotateCcw } from 'lucide-react';
import { RETRY_MESSAGE } from '../../../utils/toolCalls';

interface ToolErrorBodyProps {
  message: string;
  canRetry: boolean;
  disabled?: boolean;
  onToolAction?: (text: string) => void;
}

/**
 * 失敗表示。生成系ツールなら「同じ設定でもう一度」でモデルに再提案させる。
 */
const ToolErrorBody: React.FC<ToolErrorBodyProps> = ({ message, canRetry, disabled = false, onToolAction }) => (
  <div className="flex flex-wrap items-center justify-between gap-2">
    <p className="text-xs text-rose-600">{message}</p>
    {canRetry && onToolAction && (
      <button
        type="button"
        className="inline-flex items-center gap-1 rounded-md border border-gray-300 px-2.5 py-1 text-xs text-gray-700 hover:bg-gray-50 disabled:opacity-50"
        disabled={disabled}
        onClick={() => onToolAction(RETRY_MESSAGE)}
      >
        <RotateCcw className="h-3 w-3" aria-hidden="true" />
        同じ設定でもう一度
      </button>
    )}
  </div>
);

export default ToolErrorBody;
